export default __webpack_public_path__ + "img/maceys-perks.png";